import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Swiper, { Navigation, Pagination } from "swiper";
// Timeline Carousel
var testimonials = new Swiper(".swiper-testimonials", {
    modules: [Navigation, Pagination],
    loop: false,
    effect: "fade",
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});
